import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({
  name: 'image',
  standalone: true,
})
export class ImagePipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value === 'object' || !value) {
      return 'assets/images/logo.jpg';
    }
    if (value.includes('http') || value.includes('https')) return `${value}`;
    return `${environment.imageURL}/${value}`;
  }
}
